import { IAppConfig, runApp } from 'ice';

export const appConfig: IAppConfig = {
  app: {
    rootId: 'ice-container',
    // renderComponent: RenderTtml,
  },
  router: {
    type: 'browser',
  },
  // router: {
  //   modifyRoutes: (routes: any) => {
  //     const _routes = routes?.filter((d) => d.path.indexOf('*') > -1);
  //     console.log('路由ssr：', _routes);
  //     return _routes;
  //   },
  // },
  // // @ts-ignore
  // request: {
  //   baseURL: Config.apiBaseUrl,
  //   headers: {
  //     'Content-Type': 'application/json;charset=utf-8',
  //   },
  //   interceptors: {
  //     request: {
  //       onConfig: (config) => {
  //         return {
  //           ...config,
  //         };
  //       },
  //     },
  //     response: {
  //       onConfig: async (resp) => {
  //         const code = resp?.data?.code ?? -1;
  //         if (code >= 40000 && code < 41000 && !showModal) {
  //           showModal = true;
  //         }
  //         return resp;
  //       },
  //     },
  //   },
  // },
};

runApp(appConfig);
